import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { MasterConditionManagement } from '../modal';

export default function reducer(state: MasterConditionManagement = new MasterConditionManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.MASTER_CONDITION_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.MASTER_CONDITION_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.MASTER_CONDITION_MGMT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
